import axios from "axios";
import { Constants } from "../utils/constants";
import { CookieService } from './cookie.service';
import { Utils } from "../utils/utils";

const getAuthAnsid = () => CookieService.getCookie('ANsid');

export const getPlacements = (campaignId, filterObj, versionOneApi = "V1") => {
  let firlterParams = {};
  if (filterObj) {
    firlterParams = filterObj;
  }
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios
    .get(url + '/' + campaignId + '/placements',
      {
        params: { ...firlterParams },
        headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
      })
    .then((response) => response);
};

export const searchPlacements = (campaignId, params, versionOneApi = 'V1') => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios
    .get(url + '/' + campaignId + '/placements',
      {
        params: { ...params },
        headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
      })
    .then((response) => response);
};

export const updatePlacement = (campaignId, placementId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + '/' + campaignId + '/placements/' + placementId, payload, {
    headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const movePlacement = (campaignId, placementId, payload, versionOneApi) => {
  const url = versionOneApi === "V1" ? `${Constants.CampaignDataUrl}` : `${Constants.CampaignDataUrlV2}`;
  return axios.put(url + '/' + campaignId + '/placements/' + placementId, payload, {
    headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
  }).then((response) => response);
};

export const createPlacement = (campaignId, placementPayload) => {
  return axios
    .post(Constants.CampaignDataUrl + '/' + campaignId + '/placements',
      placementPayload, {
      headers: { ansid: CookieService.getCookie("ANsid"), clientid: Utils.getRouteParam("clientid") }
    }).then((response) => response);
};

export const deletePlacement = (campaignId, placementId, payload) => {
  return axios
    .put(Constants.CampaignDataUrl + '/' + campaignId + '/placements/' + placementId, payload, {
      headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
    }).then((response) => response);
};

export const copyPlacements = (sourceCampaignId, payload) => {
  return axios
    .post(Constants.CampaignDataUrl + '/' + sourceCampaignId + '/placements/copy', payload, {
      headers: { ansid: getAuthAnsid(), clientid: Utils.getRouteParam("clientid") }
    }).then((response) => response);
};
